import { type PropsWithChildren, useContext, useEffect, useMemo, useState } from 'react';

import Loader from './Loader';
import SplashContext from './SplashContextType';

const SplashProvider = ({ children }: PropsWithChildren<{ inner?: boolean }>) => {
  const [loaders, setLoaders] = useState(0);
  const [open, setOpen] = useState(false);
  const [canClose, setCanClose] = useState(false);

  useEffect(() => {
    if (loaders <= 0 && canClose) {
      setOpen(false);
      setCanClose(false);
    }
  }, [loaders, canClose]);

  const value = useMemo(() => {
    const setLoaderState = (value: boolean) => {
      setTimeout(() => {
        setCanClose(true);
      }, 200);

      if (value) {
        setOpen(true);
        setCanClose(false);
      }
    };

    const addLoader = () => {
      setLoaderState(true);
      setLoaders((prevLoaders) => prevLoaders + 1);
    };
    const removeLoader = () => {
      setLoaders((prevLoaders) => (prevLoaders > 0 ? prevLoaders - 1 : 0));
    };

    return { addLoader, removeLoader };
  }, []);

  return (
    <SplashContext.Provider value={value}>
      <Loader open={open} />
      {children}
    </SplashContext.Provider>
  );
};

export default SplashProvider;
export const useLoaderContext = () => useContext(SplashContext);
